import { z } from "zod";

/** Un locataire peut être "actuel" (en place / à venir) ou "ancien" (historique). */
export const LocataireTypeSchema = z.enum(["actuel", "ancien"]);
export type LocataireType = z.infer<typeof LocataireTypeSchema>;

export const LocataireSchema = z.object({
  id: z.string(),
  bien_id: z.string(),
  nom: z.string().default(""),
  email: z.string().default(""),
  telephone: z.string().default(""),
  type: LocataireTypeSchema,
  dateDebut: z.string().default(""),
  dateFin: z.string().default(""),
  // Données de contrat issues de Rentio (cf. migration 020).
  // Ces champs voyagent avec le locataire quand il passe en type='ancien'
  // → le modal historique les affiche.
  loyerInitial: z.string().default(""),
  loyerActuel: z.string().default(""),
  chargesInitiales: z.string().default(""),
  chargesActuelles: z.string().default(""),
  indexBaseYear: z.string().default(""),
  created_at: z.string().optional(),
  updated_at: z.string().optional(),
});
export type LocataireRow = z.infer<typeof LocataireSchema>;

/** Partial schema for UPDATE — id / bien_id / timestamps are excluded. */
export const LocataireUpdateSchema = LocataireSchema
  .omit({ id: true, bien_id: true, created_at: true, updated_at: true })
  .partial();
export type LocataireUpdate = z.infer<typeof LocataireUpdateSchema>;

/** Payload for INSERT — nom obligatoire, le reste optionnel. */
export const LocataireInsertSchema = z.object({
  bien_id: z.string(),
  nom: z.string(),
  email: z.string().default(""),
  telephone: z.string().default(""),
  type: LocataireTypeSchema.default("actuel"),
  dateDebut: z.string().default(""),
  dateFin: z.string().default(""),
  loyerInitial: z.string().default(""),
  loyerActuel: z.string().default(""),
  chargesInitiales: z.string().default(""),
  chargesActuelles: z.string().default(""),
  indexBaseYear: z.string().default(""),
});
export type LocataireInsert = z.infer<typeof LocataireInsertSchema>;
